/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { InvoiceItem } from './InvoiceItem'
import { Patient } from './Patient'

export class EfactInvoice {
  constructor(json: JSON | any) {
    Object.assign(this as EfactInvoice, json)
  }

  patient?: Patient
  ioCode?: string
  items?: Array<InvoiceItem>
  reason?: EfactInvoice.ReasonEnum
  invoiceRef?: string
  invoiceNumber?: number
  ignorePrescriptionDate?: boolean
  hospitalisedPatient?: boolean
  creditNote?: boolean
  relatedInvoiceIoCode?: string
  relatedInvoiceNumber?: number
  relatedBatchSendNumber?: number
  relatedBatchYearMonth?: number
}
export namespace EfactInvoice {
  export type ReasonEnum = 'Chimiotherapy' | 'ProfessionalDisease' | 'WorkAccident' | 'Accident' | 'Other'
  export const ReasonEnum = {
    Chimiotherapy: 'Chimiotherapy' as ReasonEnum,
    ProfessionalDisease: 'ProfessionalDisease' as ReasonEnum,
    WorkAccident: 'WorkAccident' as ReasonEnum,
    Accident: 'Accident' as ReasonEnum,
    Other: 'Other' as ReasonEnum,
  }
}
